import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <h1>Fit <img src="apple-touch-icon.png" alt="T" style={{ width: "30px", height: "auto", verticalAlign: "baseline" }} />racker</h1>
        </div>
    )
}

export default Header
